<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <router-link
                class="btn btn-sm btn-outline-info"
                :to="{ name: 'pos-cuponera' }"
              >
                <i class="fas fa-angle-double-left"></i>
                Atras
              </router-link>
              
              <div class="row">
                <div class="col-8 row">
                  <div class="col-12">
                    <h5 class="form-header">
                    <h5 v-if="!current.id" class="">Agregar nuevo cupón</h5>
                    <h5 v-if="current.id" class="">
                      Información de cupon<span class="text-success"> # {{ current.id }}</span
                      >&nbsp;
                      <span
                        class="badge"
                        v-bind:class="{
                          'badge-success': current.estatus == true,
                          'badge-danger': current.estatus == false,
                        }">
                        <div v-if="current.estatus == true">ACTIVO</div>
                        <div v-if="current.estatus == false">INACTIVO</div></span>
                    </h5>
                    &nbsp;
                    </h5>
                  </div>
                  <div class="col-3">
                    <label>Fecha inicio</label>
                    <input
                      :readonly="current.estado == 'B'"
                      type="date"
                      class="form-control"
                      v-model="current.fecha_inicio"                      
                      ref = "inputFechaInicio"
                      @click="openDatePicker"
                      :min = "fechaMinima"
                      id="inputFechaInicio"
                    />
                    <small
                      class="text-danger"
                      v-if="current.errors && current.errors.fecha_inicio"
                      >{{ current.errors.fecha_inicio }}</small
                    >
                  </div>
                  <div class="col-3">
                    <label>Fecha fin</label>
                    <input
                      :disabled="current.estado == 'B'"
                      type="date"
                      class="form-control"
                      v-model="current.fecha_fin"
                      ref="inputFechaFin"
                      :readonly="current.estado == 'B'"
                      @click="openDatePicker"
                      :min = "fechaMinima"
                      id="inputFechaFin"
                    />
                    <small
                      class="text-danger"
                      v-if="current.errors && current.errors.fecha_fin"
                      >{{ current.errors.fecha_fin }}</small
                    >
                    <br />
                  </div>
                  <div class="col-6">
                    <label>Nombre cupón</label>
                    <input
                      :disabled="current.estado == 'B'"
                      type="text"
                      v-model="current.nombre"
                      class="form-control" 
                    />
                    <small 
                      class="text-danger"
                      v-if="current.errors && current.errors.nombre"
                      >{{ current.errors.nombre }}</small
                    >
                    <br />
                  </div>
                  <div class="col-3">
                    <label>Cantidad de cupones</label>
                    <input
                      :disabled="current.estado == 'B'"
                      type="number"
                      class="form-control"
                      v-model="current.cant_cupones"
                    />
                    <small
                      class="text-danger"
                      v-if="current.errors && current.errors.cant_cupones"
                      >{{ current.errors.cant_cupones }}</small
                    >
                    <br />
                  </div>
                  <div class="col-3">
                    <label>Cant. max. de cupones por fact.</label>
                    <input
                      :disabled="current.estado == 'B'"
                      type="number"
                      class="form-control" 
                      v-model="current.cant_maxima_cupones"
                    />
                    <small
                      class="text-danger"
                      v-if="current.errors && current.errors.cant_maxima_cupones"
                      >{{ current.errors.cant_maxima_cupones }}</small
                    >
                    <br />
                  </div>
                  <div class="col-3">
                    <label>Valor minimo de factura (Q)</label>
                    <input
                      :disabled="current.estado == 'B'"
                      type="number"
                      class="form-control"
                      v-model="current.minimo_de_factura"
                    />
                    <small
                      class="text-danger"
                      v-if="current.errors && current.errors.minimo_de_factura"
                      >{{ current.errors.minimo_de_factura }}</small
                    >
                    <br />
                  </div>
                  <div class="col-3">
                    <label>Por cada (Q)</label>
                    <input
                      :disabled="current.estado == 'B'"
                      type="number"
                      class="form-control"
                      v-model="current.por_cada"
                    />

                    <small
                      class="text-danger"
                      v-if="current.errors && current.errors.por_cada"
                      >{{ current.errors.por_cada }}</small
                    >
                    <br/>
                  </div>
                  
                  <div class="col-3 form-check" v-if="cuponeraCreada">    
                    <label class="form-check-label">
                      Estatus de cupón: &nbsp;
                    </label> 
                    <label class="switch">
                      <input 
                        type="checkbox"            
                        :disabled="!cuponeraCreada || estado_fecha_cupon=='A'"            
                        v-model="current.estatus"
                        @change="activarInactivarCupon()"
                       
                      >
                      <span class="slider-button"></span>
                    </label>
                  </div>
                  <div class="col-5" v-if="cuponeraCreada">                    
                    <label class="form-check-label">
                      ¿Limitar listado por detalle de producto? &nbsp;
                    </label>                    
                    <label class="switch">
                      <input                                         
                        v-model="current.limitar_listado"
                        type="checkbox"
                        @change="CambiarTipoListado()"
                        :disabled = "!cuponeraCreada"
                      >  
                      <span class="slider-button"></span>
                    </label>   
                  </div>  
                </div>
                &nbsp; &nbsp;
                <div class="col-4">      
                  <label class="form-check-label">
                    Agregar multiplicador &nbsp;
                  </label>                    
                  <label class="switch"
                    :title="cuponeraCreada && multiplicador_activado? 'No se puede desactivar porque ya esta guardado':'No se puede activar porque ya está guardado'"
                  >
                    <input                                             
                      v-model="multiplicador_activado"
                      type="checkbox"    
                      :disabled="cuponeraCreada"                                    
                    >  
                    <span class="slider-button"></span>
                  </label>                  
                  <div                           
                    :class="['mt-3', multiplicador_activado ? 'bg-info text-white':'bg-light text-dark']"                   
                    style="
                      border: 0.5px solid rgba(138, 137, 137, 0.437);
                      border-radius: 15px;
                      height: 200px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.2);
                      transition: background-color 0.5s ease, color 0.5s ease;
                    "
                  >
                  <div style="text-align: center">
                    <h5 style="margin-top: -10px; margin-bottom: 25px">
                      <i class="fas fa-calculator"></i>&nbsp;
                      <i class="fas fa-times"></i> &nbsp; Multiplicador de Cupones
                    </h5>
                    <div class="row mt-0">
                      <div class="col-5 ml-3">
                        <label> Cant. maxima de cupones </label>
                        <input
                          :disabled="current.estado == 'B' || !multiplicador_activado"
                          type="number"
                          class="form-control"
                          v-model="current.cant_maxima_cupones_multi"
                        />
                        <small
                          class="text-danger"
                          v-if="current.errors && current.errors.cant_maxima_cupones_multi"
                          >{{ current.errors.cant_maxima_cupones_multi }}</small
                        >
                        <!-- <small
                          class="text-danger"
                          v-if="current.errores && current.errores.cant_maxima_cupones_invalid"
                          > {{ current.errores.cant_maxima_cupones_invalid }}</small
                        > -->
                      </div>
                      <div class="col-1">
                        &nbsp;
                      </div>
                      <div class="col-5 mr-1">
                        <label>Multiplicador</label>
                        <input
                          :disabled="current.estado == 'B' || !multiplicador_activado" 
                          type="number"
                          class="form-control"
                          v-model="current.multiplicador"
                        />
                        <small
                          class="text-danger"
                          v-if="current.errors && current.errors.multiplicador"
                          >{{ current.errors.multiplicador }}</small
                        >
                        <!-- <small
                          class="text-danger"
                          v-if="current.errores && current.errores.multiplicador_invalid"
                          >{{ current.errores.multiplicador_invalid }}</small
                        > -->
                      </div>
                      <div class="col-5 ml-3 mt-2">
                        <label>Hora Inicio </label>
                        <input
                          :disabled="current.estado == 'B' || !multiplicador_activado" 
                          type="time"
                          class="form-control"
                          v-model="current.hora_inicio"
                        />
                        <small
                          class="text-danger"
                          v-if="current.errors && current.errors.hora_inicio"
                          >{{ current.errors.hora_inicio }}</small
                        >
                      </div>

                      <div class="col-1">
                        &nbsp;
                      </div>
                      <div class="col-5 mr-1 mt-2">
                        <label>Hora Fin</label>
                        <input
                          :disabled="current.estado == 'B' || !multiplicador_activado" 
                          type="time"
                          class="form-control"
                          v-model="current.hora_fin"
                        />       
                        <small
                          class="text-danger"
                          v-if="current.errors && current.errors.hora_fin"
                          >{{ current.errors.hora_fin }}</small
                        >            
                      </div>
                    </div>
                  </div>
                </div>
              </div>                      
            </div>
            <div class="form-buttons-w">
              <button
                class="btn btn-md btn-block btn-success mx-2"
                v-if="current.estado == 'A'"
                type="button"
                @click="guardar()"
              >
                Guardar cupon
              </button>
            </div>     
            <div v-if="cuponeraCreada" class="row ml-1 border border-3">          
              <div>
                <button class="btn btn-info text-white" 
                  data-toggle="modal" 
                  data-target="#agregarProductosModal"             
                  :disabled="!cuponeraCreada || !current.limitar_listado"
                >
                  <i class="fa fa-plus"></i>Agregar productos           
                </button>                
                <button class="btn btn-outline-info" 
                  data-toggle="modal" 
                  data-target="#exampleModal"
                  v-if="!current_qr.landing_url "
                  :disabled="!cuponeraCreada || estado_fecha_cupon =='E'"
                >
                  <i class="fa fa-plus"></i> Agregar Qr              
                </button>
              
                <!-----Redireccion hacia url de la imagen si ya existe------->            
                &nbsp; &nbsp;
                <a :href=current_qr.landing_url target="_blank" style = "text-decoration: none;">
                  <button class="btn btn-outline-info"               
                    v-if="current_qr.landing_url"                    
                  >
                    <i class="fa fa-image"></i>
                      Ver Qr Oferta
                  </button>
                </a>                
              </div>            
            </div>
            <br />
            <!---------------------------SELECTOR DE TIENDAS---------------->
            <div v-if="cuponeraCreada">
              <h6 class="text-left mt-3">&nbsp; &nbsp; &nbsp;Tiendas donde aplicará el cupón: </h6>
              <Multiselect                      
                v-model="tiendasSelected"                
                :options="tiendas"
                :multiple="true"
                :close-on-select="false"
                placeholder="Elige las tiendas"
                label="nombre"
                track-by="codigo"               
                @select="onSelect"
                @remove="onRemove"
                v-if="tiendas" 
              >
              </Multiselect>  
            </div>   
            <hr> 
              <!-- -----------------FIN DE SELECTOR DE TIENDAS----------------------->  
              <!-------------------TABLA DETALLE DE PRODUCTOS PARTICIPANTES----------------->            
              <div class="row" v-if="listaProductos.length>0"> 
                <div class="col-12 border border-3 p-3 rounded" style="padding-right: 0px" >
                  <div class="" >              
                    <h5 class="text-center ">Detalle de productos participantes</h5>             
                      <nav class="border border-primary rounded-top">
                        <div class="nav nav-tabs" id="nav-tab" role="tablist">														
                          <a
                            class="col col-sm-3 nav-item nav-link active"
                            id="reglas_agregacion"
                            data-toggle="tab"
                            href="#reglas_content"
                            role="tab"
                            aria-controls="nav-home"
                            aria-selected="true"
                          >
                            Elementos agregados
                          </a>
                          <a
                            class="col col-sm-3 nav-item nav-link"
                            id="detalle_productos"
                            data-toggle="tab"
                            href="#detalle_content"
                            role="tab"
                            aria-controls="nav-home"
                            aria-selected="true"
                          >
                            Detalle de Productos
                          </a
                          >
                        </div>
                      </nav>
                      <div class="tab-content" id="nav-tabContent">
                        <div
                          class="tab-pane fade show active "
                          id="reglas_content"
                          role="tabpanel"
                          aria-labelledby="nav-home-tab"
                        >
                          <div style="max-height: 550px; overflow-y:auto">
                            <table class="table table-striped table-hover">
                              <thead>
                                <tr class="table-dark">
                                  <th class="text-dark">
                                    Origen
                                  </th>
                                  <th class="text-dark">
                                    Codigo y descripción
                                  </th>
                                  <th class="text-dark">
                                    Cantidad de Productos
                                  </th>
                                  <th class="text-dark">
                                    Opciones
                                  </th>
                                </tr>
                              </thead>                            
                              <tbody>
                                <template v-for="e in elementosAgregados">
                                  <tr>
                                    <td>
                                      {{ e.origen=='C' ? 'Categoria:': e.origen == 'S'? 'Subcategoria:' : e.origen =='P' ? 'Proveedor:': e.origen == 'PC' ? 'Proveedor-Categoria:': e.origen == 'PS' ? 'Proveedor-Subcategoria:': ''  }} 
                                    </td>
                                    <td>                                    
                                      {{ e.origen=='C' ? e.categoria : e.origen == 'S'? e.subcategoria : e.origen =='P' ? e.proveedor : e.origen == 'PC' ? "[" + e.proveedor : e.origen == 'PS' ? "[" + e.proveedor + " - " + e.proveedor_nombre: ''  }} 
                                      {{ e.origen=='C' ? " -- "+ e.categoria_nombre : e.origen == 'S'?  " -- "+ e.subcategoria_nombre : e.origen =='P' ? e.proveedor_nombre : e.origen == 'PC' ? " - " + e.proveedor_nombre + "] >> " + "[" + e.categoria + " - "+ e.categoria_nombre + "]": e.origen == 'PS' ? "] >> [" + e.subcategoria + " - " + e.subcategoria_nombre + "]": ''  }}                                     
                                    </td>
                                    <td>
                                      {{ e.total_productos }}
                                    </td>
                                    <td>
                                      <button class="btn btn-danger"
                                        @click="eliminarGrupo(e)">
                                        <i class="fa fa-trash">
                                        </i>
                                      </button>
                                    </td>     
                                  </tr>
                                </template>                              
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div
                          class="tab-pane fade "
                          id="detalle_content"
                          role="tabpanel"
                          aria-labelledby="nav-home-tab"
                        >
                          <div>                           
                            <h6>Productos en cupón ({{ listaProductos.length}}) </h6>
                          </div>
                          <div style="max-height: 550px; overflow-y:auto">
                            <table class="table table-striped table-hover">
                              <thead>
                                <tr class="table-dark">
                                  <th class="text-dark text-center" style="width: 20% !important">SKU</th>
                                  <th class="text-dark text-center">Nombre</th>                                
                                  <th class="text-dark" v-if="!current.limitar_listado">Opciones</th>
                                </tr>
                              </thead>
                              <tbody>
                                <template v-for="elemento in listaProductos">
                                  <tr >
                                    <td class="text-center">{{ elemento.sku}}</td>    
                                    <td>{{ elemento.producto}}</td>                                                                
                                    <td v-if="!current.limitar_listado">
                                      <button
                                        @click="eliminarProducto(elemento)"
                                        :disabled="
                                        current.estatus == false || current.limitar_listado == false"
                                        class="btn btn-danger btn-sm"
                                      >
                                        <i class="far fa-trash-alt"></i> Eliminar
                                      </button>
                                    </td>
                                  </tr>  
                                </template>                                    
                              </tbody>
                            </table>
                          </div>  
                        </div>
                      </div>      
                  </div>      
                </div>
                <!-------------------- END - Basic Table -------------------->  
              </div>             
            </div>              
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Agregar Qr Ofertas</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group">
                <label for="nombre-qr" class="col-form-label">Nombre:</label>
                <input type="text" class="form-control" id="nombre-qr-ofertas" v-model="current_qr.nombre"
                  maxlength="95">
              </div>
              <div class="form-group">
                <label for="descripcion-qr" class="col-form-label">Descripción: </label>
                <textarea class="form-control" id="descripcion-qr-ofertas" v-model="current_qr.descripcion">
                </textarea>
              </div>
              <div class="form-group mt-4">
                <label for="imagen" class="col-form-label">Imagen:</label>&nbsp;&nbsp;                
                  <!-------------------------INPUT OCULTO PARA ELEGIR ARCHIVO----------------->
                  <input type="file" id="file" style="display: none" ref="file" v-if="current.id"
                   @change="validarArchivoImagen" accept="image/*"/>
                  <!----------------------boton CAMBIAR FOTO --------------------------->
                  <button v-if="file == '' && current.id" class="btn btn-info btn-sm" type="button"
                    @click="cambiarfoto">
                    <i class="os-icon os-icon-image text-white"></i>
                    <span class="text-white">Agregar imagen</span>
                  </button>
                  <!-----------------------------BOTON CANCELAR FOTO------------------------>
                  <span v-if="file != ''" class="text-info">{{ file.name }}</span> &nbsp;
                  <button v-if="file != ''" class="btn btn-danger btn-sm " type="button" @click="cancelarFoto">
                    <i class="os-icon os-icon-close"></i>                    
                  </button>
                  <!-----------------------------BOTON SUBIR FOTO------------------------>
                  <!-- <button v-if="file != ''" class="btn btn-success btn-sm" type="button" @click="submitFile">
                    <i class="os-icon os-icon-image"></i>
                    <span>Subir</span>
                  </button> -->
               
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitFile"> Guardar</button>
          </div>
        </div>
      </div>
    </div>
    
    <CategoriaSeleccionComponent :cuponera="current.id" @refreshCuponeraSku="refreshCuponeraSku"/>

  </div>  
</template>

<script>
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";
import CuponeraModelAddComponent from "@/components/pos/cuponera/CuponeraModelAddComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";
import ProductoSelectComponent from "@/components/commons/ProductoSelectComponent";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import CuponeraModelAddListadoComponent from "@/components/pos/cuponera/CuponeraModelAddListadoComponent";
import Multiselect, { multiselectMixin } from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css'
import CategoriaSeleccionComponent from "@/components/pos/cuponera/CategoriaSeleccionComponent";

export default {
  components: {
     CuponeraModelAddComponent,
     PaginationComponent,
     ProductoSelectComponent,
     ProveedoresSelectComponent,
     CuponeraModelAddListadoComponent,
     Multiselect,
     CategoriaSeleccionComponent
  },
  data() {
    return {
      current: {
        estado: "A",
        estatus: false,
        tienda: "",
        fecha: "",
        errors: {
          fecha_inicio: "",
          fecha_fin: "",
          nombre:"",
          cant_cupones:null,
          cant_maxima_cupones: null,
          minimo_de_factura:null,
          por_cada:null,
          cant_maxima_cupones_multi: null,
          multiplicador: null,
          hora_inicio: null,
          hora_fin:null,
        },
        errores:{          
          cant_maxima_cupones_invalid: '',
          multiplicador_invalid: ''
        },
        usuario: "",
        fecha_inicio: "",
        fecha_fin: "",
        tipos_liq: "",
        producto: "",
        hora_inicio: null,
        hora_fin: null,
        cant_maxima_cupones_multi: null,
        multiplicador:null
        
      },
      detalle: {},
      tipos_liq: [],
      tiendas: [],
      currentDetalle: {},
      tiendas: "",     
      cuponeraCreada:false,
      listaProductosCompleta:[],     
      listaProductos:[],     
      tiendasBd: [],
      fechaHoy: '',           
      currentPage: 1,
      filter: {},
      primeraCarga: false,
      tiendasSelected:[],
      multiplicador_activado: false,
      multiplicador_bloqueado:false,
      file:"",
      current_qr: {
        nombre:"",
        descripcion:"",
        file:"",        fecha_inicio:"",
        fecha_fin:"",
        nombre: "",
        descripcion:"",
        file:"",       
        landing_url:"",
      },
      loading: false,
      tipoSelected: "categoria",
      categoriasAgregadas: [],
      subcategoriasAgregadas: [],
      busqueda:{
        categorias:[],
        subcategorias:[],
        proveedores:[],
      },
      filtros:{
        categorias:[],
        subcategorias:[],
        proveedores:[],
      },
      elementosAgregados:[],
      estado_fecha_cupon: "",
    };
  },
  watch:{
    multiplicador_activado(val){      
      if(!val){
        this.current.cant_maxima_cupones_multi= null;
        this.current.multiplicador=null;
        this.current.hora_inicio = null;
        this.current.hora_fin = null;
        this.current.errors.cant_maxima_cupones_multi = null;
        this.current.errors.multiplicador = null;
        this.current.errors.hora_inicio = null;
        this.current.errors.hora_fin = null;
      }      
    }, 
  },
  computed: {
    verificarFechaFinalCupon(){     
      let self = this;
      let enVigencia;
      if(self.current.fecha_fin >= self.fechaHoy){         
        enVigencia = true;
      }else{
        enVigencia = false;        
      }
      return enVigencia;
    },
    fechaMinima(){
      return this.aumentarUnDia(this.fechaHoy);
    },
  },
  created() {
    let self = this;    
    self.obtenerTiendas().then(()=>{      
      if (this.$route.params.id) {        
        self.refreshCurrent();
      }
    });     
    //obtener fecha actual
    const hoy = new Date();
    self.fechaHoy = hoy.toISOString().split('T')[0]; 
  },  
  methods: {
    openDatePicker(e){
      e.target.showPicker && e.target.showPicker();
    },
    verificarEstatusFechaCupon(){
      let self=this;
      //Creando estatus por fecha de cupon
      if(self.fechaHoy < self.current.fecha_inicio){ 
        //Estado I - Inactivo porque no ha llegado a su fecha de inicio   
        self.estado_fecha_cupon = 'I'
        return         
      }
      if(self.current.fecha_inicio <= self.fechaHoy &&
          self.fechaHoy <= self.current.fecha_fin){ 
            //Estado A - Activo, esta en el rango de fechas correcto          
            self.estado_fecha_cupon = 'A'
            return         
      }
      if(self.current.fecha_fin < self.fechaHoy){ 
        //Estado 'E'  Expirado, ya pasó su fecha de fin 
        self.estado_fecha_cupon = 'E'
        return         
      }
    },
    aumentarUnDia(fecha){
      let self=this;      
      let dia = fecha.split("-")[2]
      let mes = fecha.split("-")[1]
      let año = fecha.split("-")[0]
      dia =parseInt(dia)+1

      let fechaUnDiaDespues = año+"-"+mes+"-"+dia  
      return fechaUnDiaDespues
    },
    CambiarTipoListado() {    
      let self = this;
      let texto
      if(self.current.limitar_listado == true){
        texto = "Al activar limitar el listado se dará cupones sólo por los productos seleccionados"
      }else{
        texto = "Al desactivar limitar el listado se darán cupones para el total de la factura"
      }

      swal({
        title: "Cambiar tipo de listado",
        text: texto,
        icon: "info",
        buttons: ["Cancelar","Sí"],
        dangerMode: false
      }).then((result) => {
        if (result) {            
          DynamicService.postAction(
            "cat",
            "cuponera",
            self.current.id,
            "cambiar_tipo_listado"
          )
          .then((response) => {
            Notifications.alert.success("Cambiar tipo listado", "Realizado correctamente");
            return;
          })
          .catch((errors) => {
            self.current.errors = errors.response.data;
            return
          });       
        }else{
          self.current.limitar_listado = !self.current.limitar_listado
        }        
      });
    },  
    activarInactivarCupon() {
      //activa o inactiva cupon
      let self = this;      
      let titulo;
      let texto;      
      let puedeContinuar = true;
      let estadoTemporal = self.current.estatus;
      let cuponEnVigencia = self.verificarFechaFinalCupon;

      if(this.current.estatus && cuponEnVigencia==true){        
        titulo = "Activar cupón",
        texto = "Si realiza esta acción se empezarán a imprimir los cupones en las tiendas"        
      }else{
        if(this.current.estatus && cuponEnVigencia==false){        
          titulo = "Activar cupón",
          texto = "No se puede activar el cupon porque ya expiró"
          puedeContinuar = false;          
        }else{          
          if(this.current.estatus==false && cuponEnVigencia==true){        
            titulo = "Inactivar cupón",
            texto = "Estas seguro que deseas inactivar el cupón?"          
          }
        }
      }     
      swal({
        title: titulo,
        text: texto,
        icon: puedeContinuar ? "warning" : "error",
        buttons: puedeContinuar ? ["No", "Si"] : ["Cerrar"],
        dangerMode: !puedeContinuar
      }).then((result) => {
        if (!puedeContinuar) {                 
          self.current.estatus = false;          
        } 
        if(!result){
          self.current.estatus = !estadoTemporal;
        }else{
          self.guardar(); //se cambia estado en checkbox   
        }
      });
    },
    guardar() {
      let self = this;
      if(!self.current.errores){
        self.current.errores={}
      }

      const fechaInicio = self.current.fecha_inicio;
      const fechaFin = self.current.fecha_fin;      

      self.current.errors = {}

      /** Validaciones de fecha vacía */     

      if(!fechaInicio && !fechaFin){        
        self.current.errors.fecha_inicio = "Fecha inicio es requerido"
        self.current.errors.fecha_fin = "Fecha fin es requerido"    
      }
      if(!fechaInicio && fechaFin){        
        self.current.errors.fecha_inicio = "Fecha inicio es requerido"   
      }
      if(!fechaFin && fechaInicio){        
        self.current.errors.fecha_fin = "Fecha fin es requerido"    
      }

      /**Validaciones de fechas correctas */

      if(fechaInicio && fechaFin && fechaInicio>fechaFin){        
        self.current.errors.fecha_inicio = "Fecha inicio no puede ser mayor a fecha final"       
        self.current.errors.fecha_fin = "Fecha fin no puede ser menor a fecha inicio"
      }
      if(fechaInicio == fechaFin){        
        self.current.errors.fecha_inicio = "Fechas no pueden ser iguales"
        self.current.errors.fecha_fin = "Fechas no pueden ser iguales"     
      }   

      /**Validaciones de campos vacíos (info de cupón) */
      if(!self.current.nombre){
        self.current.errors.nombre = "Nombre es requerido"        
      }
      if(!self.current.cant_cupones){        
        self.current.errors.cant_cupones ="Cantidad de cupones es requerido"
      }
      if(self.current.cant_cupones == 0){        
        self.current.errors.cant_cupones ="Cantidad de cupones no puede ser 0"
      } 
      if(!self.current.cant_maxima_cupones){
        self.current.errors.cant_maxima_cupones = "Cantidad máxima de cupones es requerida"        
      }
      if(self.current.cant_maxima_cupones == 0){        
        self.current.errors.cant_maxima_cupones ="Cantidad maxima de cupones no puede ser 0"
      } 
      if(!self.current.minimo_de_factura){
        self.current.errors.minimo_de_factura = "Valor mínimo de factura es requerido"      
      }
      if(self.current.minimo_de_factura == 0){
        self.current.errors.minimo_de_factura = "Valor mínimo no puede ser 0"      
      }
      if(!self.current.por_cada){
        self.current.errors.por_cada = "Por cada es requerido"     
      }          
      if(self.current.por_cada == 0){        
        self.current.errors.por_cada = "Por cada no puede ser 0"     
      }  

      /**Validaciones de campos en multiplicador de cupones */
      let hay_errores_multiplicador=false;
      if(self.multiplicador_activado){           
        if(self.current.cant_maxima_cupones_multi===null){
          self.current.errors.cant_maxima_cupones_multi = "Cant. maxima es requerido"
        }
        if(self.current.cant_maxima_cupones_multi && self.current.cant_maxima_cupones_multi<=1){
          self.current.errors.cant_maxima_cupones_multi = 'Cant. debe ser mayor a 1'    
        }
        if(self.current.multiplicador==null){
          self.current.errors.multiplicador = 'Multiplicador es requerido'    
        }
        if(self.current.multiplicador && self.current.multiplicador<=1){          
          self.current.errors.multiplicador = 'Multiplicador debe ser mayor a 1'               
        }

        /**Validaciones de hora inicio y hora fin */

        if(!self.current.hora_inicio) {          
          self.current.errors.hora_inicio = "Hora inicio es requerida"
        }
        if(!self.current.hora_fin) {          
          self.current.errors.hora_fin = "Hora fin es requerida"
        }

        /**Verificación de hora valida, hora de inicio debe ser menor a hora fin */

        if(self.current.hora_inicio > self.current.hora_fin){          
          self.current.errors.hora_inicio = "Hora inicio no puede ser mayor a hora fin"
          self.current.errors.hora_fin = "Hora fin no puede ser menor a hora inicio"
        }
        if(self.current.hora_inicio === self.current.hora_fin){          
          self.current.errors.hora_inicio = "Horas no pueden ser iguales"
          self.current.errors.hora_fin = "Horas no pueden ser iguales"
        }        

        /**Validación si hay errores en multiplicador_cupones */

        if(self.current.errors.cant_maxima_cupones || self.current.errors.multiplicador
            || self.current.errors.hora_inicio || self.current.errors.hora_fin
          ){           
            hay_errores_multiplicador = true;
          }
      }
      else{
        self.current.cant_maxima_cupones_multi= null;
        self.current.multiplicador=null;
        self.current.hora_inicio = null;
        self.current.hora_fin = null;
      }

      /**Validacion si hay algun campo que tenga errores, hacer un return y 
      * mostrar los errores
      */

      if(self.current.errors.fecha_inicio || self.current.errors.fecha_fin
        || self.current.errors.nombre || self.current.errors.cant_cupones
        || self.current.errors.cant_maxima_cupones || self.current.errors.minimo_de_factura
        || self.current.errors.por_cada || hay_errores_multiplicador
      ){
        return;
      }

      /**Formateo de fechas para guardado */
      self.current.fecha_inicio = self.dateSaveFormatter(self.current.fecha_inicio);
      self.current.fecha_fin = self.dateSaveFormatter(self.current.fecha_fin);
      self.guardarEstado = true;  

      DynamicService.save("cat", "cuponera", this.current)
        .then((response) => {
          if (this.$route.params.id) {
            Notifications.alert.success(
              "Modificar información",
              "Realizado correctamente"
            );
          }else{
            this.cuponeraCreada=true;
            Notifications.alert.success(
              "Agregar nueva cuponera",
              "Agregado existosamente, puedes agregar productos y tiendas"
            );
            this.$router.push({
              name: "pos-cuponera-editar",
              params: { id: response.data.id },
            });
          }
          this.refreshCurrent(); 
        })
        .catch((errors) => {
          this.current.errors = errors.response.data;          
        });
    },
    customFormatterInverted(date) {
      if (date == null) {
        return "";
      }
      var d = date.split("/");
      var str_d = d[2] + "-" + d[1] + "-" + d[0];
      return moment(str_d).format("YYYY-MM-DD");
    },
    dateSaveFormatter(date) {
      if (date == null) {
        return "";
      }
      return moment(date).format("DD/MM/YYYY");
    },
    imprimir() {
      let self = this;
      OrdenCompraService.pdf(self.current.id)
        .then((response) => {
          window.open(response.data.output);
        })
        .catch((error) => {
          Notifications.alert.error(
            "No se ha podido realizar la acción",
            error.response.data.detail
          );
        });
    },
    refreshCurrent() {
      let self = this;  
      
      DynamicService.getById("cat", "cuponera", this.$route.params.id).then(
        (response) => {
          
          self.current = response.data;              
          self.refreshQrOfertas();    
          self.refreshCuponeraSku({page: 1});         
          if (self.current.id) {
            self.current.estado = "B"; 
            self.cuponeraCreada = true;
          }
          self.current.fecha_inicio = this.customFormatterInverted(
            self.current.fecha_inicio
          );
          self.current.fecha_fin = this.customFormatterInverted(self.current.fecha_fin);       
         
          if(self.current.hora_inicio){
            self.current.hora_inicio = self.current.hora_inicio.substring(0,5)
          }

          if(self.current.hora_fin){
            self.current.hora_fin = self.current.hora_fin.substring(0,5)
          }
          
          if(self.current.multiplicador){
            self.current.multiplicador = parseInt(self.current.multiplicador);            
          }

          if (self.current.cant_maxima_cupones_multi) {
            self.current.cant_maxima_cupones_multi = parseInt(self.current.cant_maxima_cupones_multi);
          }     

          if(self.current.cant_maxima_cupones_multi!==null && self.current.multiplicador!==null
          && self.current.hora_inicio !==null&& self.current.hora_fin!==null){
              self.multiplicador_activado = true;          
            }          
        }
      );      
      self.primeraCarga = true;
      self.refreshCuponeraTienda();
      self.loading=true;
    },
    refreshCuponeraSku(params){
      let self= this;
      //OBTIENE PRODUCTOS AGREGADOS AL CUPON     
      params.id = this.$route.params.id           
      DynamicService.getActionList("cat", "cuponera-sku","traer_cuponera_sku",params).then(
      (response) => {  
         self.listaProductos = response.data;   
      }).catch((error)=>{             
        if(!self.primeraCarga){ 
          Notifications.alert.error(
          "Productos Agregados al cupón",
          "Error " + error.response.data.error
          )
        }
        self.primeraCarga=false;          
      })       
      self.elementosAgregadosCupon()

    },
    refreshCuponeraTienda(){    
      //Obtiene las tiendas asociadas a la cuponera  
       let self = this;
       DynamicService.getAction("cat", "cuponera-tienda", this.$route.params.id,"traer_cuponera_tienda").then(
        (response) => {                  
          self.tiendasBd = response.data;          
          self.tiendasSelected= this.cambiarEstadoTiendas(self.tiendasBd);          
        })
    },
    obtenerTiendas(){
      let self= this;
      let tiendas_temp=[];      
      return DynamicService.fetch("cat", "tiendas", {
        quitar_paginacion: true,
      }).then((response) => {
        tiendas_temp=response.data;  
        self.tiendas=[]
        Object.entries(tiendas_temp).forEach(([key, value]) => {    
          if(value.codigo_postal ==1){           
            self.tiendas.push(value)  
          }
        });             
      });   
    },
    cambiarEstadoTiendas(arregloComparar){
      //Compara arreglo recibido en parametros con el arreglo <tiendas> y devuelve
      //un arreglo con la diferencia de tiendas  
      let self=this;
      let lista_temporal = [];  
      let listaResultante = []       

      Object.entries(arregloComparar).forEach(([key, value]) => {  
        lista_temporal.push(value.tienda)
      })
      self.tiendas.forEach(t => {
        let existe = lista_temporal.includes(t.codigo); 
        if(!existe){   
          listaResultante.push(t)         
        }
      })
      return listaResultante
    }, 
    eliminarProducto(producto){
      let self= this 
      DynamicService.delete("cat", "cuponera-sku",producto.id)
        .then((response)=>{          
          self.refreshCuponeraSku({page:self.currentPage});
          Notifications.alert.success(
            "Producto eliminado",
            "El producto fue eliminado"
          )
        }).catch((error)=>{
          Notifications.alert.error(
            "Eliminar Producto", 
            "error"+error.response
          )
        })    
    },  
    onPageChange(page) {
      let self = this
      this.currentPage = page;      
      this.refreshCuponeraSku({
        page: this.currentPage 
      });
    },
    clearFilterData() {
      let self = this
      self.filter = {}      
         
      this.refreshCuponeraSku({
        page: 1, 
      });
      this.onPageChange(1)
    }, 
    filterData() {
      let self = this    
      let producto = self.filter.producto ? self.filter.producto.sku : null
      let proveedor = self.filter.proveedor ? self.filter.proveedor.codigo : null    
      this.refreshCuponeraSku({
        page: 1,
        producto: producto,
        proveedor: proveedor
      });
    },
    onSelect(option){
      let self = this;      
        let params = {
        tienda: option.codigo,
        cuponera: self.current.id,        
      }     
      DynamicService.postActionList("cat", "cuponera-tienda", "seleccion_tiendas", params)
      .then((response) =>{       
        Notifications.alert.success("Agregar Tienda", "La tienda ha sido agregada")
        this.refreshCuponeraTienda            
      }).catch((error)=>{
        Notifications.alert.error(
          "Agregar Tienda", 
          "error"+error.response
        )          
      })
    },
    onRemove(option){
      let self= this      
       let params = {
        tienda: option.codigo,
        cuponera: self.current.id,        
      }    
      DynamicService.save("cat", "cuponera-tienda",params)
      .then((response)=>{          
        Notifications.alert.success("Quitar Tienda", "La tienda ha sido eliminada")
        this.refreshCuponeraTienda
      }).catch((error)=>{
        Notifications.alert.error(
          "Error", 
          "error: " + error.response.data
        )
      })
    },
    cambiarfoto() {
      this.$refs.file.click();
    },
    cancelarFoto() {
      this.file = "";
      this.$refs.file.value="";
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0]; 
    },
    submitFile(){
      let self=this; 
      if(self.current_qr.nombre===""){      
        Notifications.alert.error(
          "Qr Ofertas",
          "Debe ingresar un nombre para la oferta"
        )
        return
      }

      if(self.current_qr.descripcion===""){    
        Notifications.alert.error(
          "Qr Ofertas",
          "Debe ingresar una descripción para la oferta"
        )
        return
      }

      if(!this.file){
        Notifications.alert.error("Error", "Debe cargar una imagen para la oferta")
        return
      }    

      if(self.current.fecha_inicio){      
        self.current_qr.fecha_inicio = self.current.fecha_inicio      
      }

      if(self.current.fecha_fin){
        self.current_qr.fecha_fin = self.current.fecha_fin      
      }
      self.current_qr.id = self.current.id

      DynamicService.saveImageWithPost("cat", "qr-ofertas", self.current_qr, self.file)
        .then((res) => {
          if(res.data){
            Notifications.alert.success("Cuponera", "Se ha guardado la qr oferta exitosamente.");
            self.refreshQrOfertas();
            $('#exampleModal').modal('hide')
          } 
        })
        .catch((error) => {
          self.file = "";      
          Notifications.alert.error("Error", error.response.data)
        });
      },
      refreshQrOfertas(){      
        let self = this;      

        let params = {
          cuponera_id: self.current.id,
        }
        DynamicService.getActionList("cat", "cuponera", "obtener_imagen_qr_ofertas", params)
        .then((response) => {          
          if(response && response.data && response.data.landing_url){            
            self.current_qr.landing_url = response.data.landing_url
          }      
        }).catch((error)=>{
          Notifications.alert.error(
            "Qr Ofertas",
            "Error al obtener la imagen de la qr oferta"+error.response.data
          )          
        })
      },
      validarArchivoImagen(){
        let self=this;
        const file = event.target.files[0];
        if(!file) return;

        const validTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
        if(!validTypes.includes(file.type)){
          Notifications.alert.error(
            "Imagen",
            "Tipo de archivo inválido, se permiten archivos de tipo (jpg, png, jpg, webp)"
          )

          self.$refs.file.value="";         
          self.file="";
          return
        }
        let tamañoMaximo = 1 * 1024 * 1024;
        if(file.size > tamañoMaximo){
          Notifications.alert.error(
            "Imagen",
            "El tamaño del archivo no puede superar 1MB"
          )
          return;
        }
        self.file=file;    
      },     
      cambiarTipo(){
        let self = this;    
      },
      filtrarProveedores(){
        let self = this;
        if(!self.filtros.proveedor){
          return;
        }
        let params = {
          proveedor: self.filtros.proveedor.proveedor,
          categoria: self.filtros.proveedor.categoria,
          subcategoria: self.filtros.proveedor.subcategoria,
          cuponera: self.current.id
        }        
        DynamicService.getActionList("cat", "cuponera-sku","get_productos_proveedor_agregado",params)
        .then((response)=>{
          self.listaProductos = []
          self.listaProductos = response.data

        })
        .catch((error)=>{
  
        })
        params = {}
        params = {
          proveedor: self.filtros.proveedor.proveedor,
          cuponera: self.current.id
        }
        DynamicService.getActionList("cat", "cuponera-sku","categoria_y_subcategoria_proveedores",params)
        .then((response)=>{
      
        })
        .catch((error)=>{
      
        })

      },
      eliminarGrupo(grupo){
        let self=this;
        let params= {
          cuponera: self.current.id,
          fecha_creacion: grupo.fecha_creacion,
          origen: grupo.origen,
          categoria: grupo.categoria,
          subcategoria: grupo.subcategoria,
          proveedor: grupo.proveedor,        
          total_productos: grupo.total_productos
        }  
        DynamicService.postActionList("cat", "cuponera-sku", "eliminar_elementos_de_cupon", params)
        .then((response)=>{          
          if(response.status == 200){            
            self.refreshCuponeraSku({page: 1})
          }
        })
        .catch((error)=>{
          Notifications.alert.error("Eliminación de grupos", error.response.data.error)
        })
      },
      elementosAgregadosCupon(){
        let self=this;        
        let params= {
          cuponera: self.current.id
        }       

        DynamicService.getActionList("cat", "cuponera-sku","elementos_agregados_cupon",params)
        .then((response)=>{          
          self.elementosAgregados = response.data          
        })
        .catch((error)=>{          
          Notifications.alert.error("Elementos agregados", error.response.data.error)
        })  
      },
    }    
};
</script>
<style>
  .badge-success.cursor-pointer:hover{
    background-color: #2d9144 !important;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    transition: background-color 0.2s, box-shadow 0.2s;

  }

</style>
 